<script>
	import GameMenu from "./pages/GameMenu.svelte";
	import GamePause from "./pages/Pause.svelte";
	import GameTutorial from "./pages/GameTutorial.svelte";
	import Game from "./pages/Game.svelte";
	import Countdown from "./pages/Countdown.svelte";
	import GameEnd from "./pages/GameEnd.svelte";

	import { gameState } from "./store";
	import Loader from "./Loader.svelte";
	import { onMount } from "svelte";

	let currentPage;
	let levelProps;
	let soundsReady = false;
	let isNewGame;

	let score, maxScore, isVictory, levelHeadphonesImage;

	gameState.subscribe((state) => {
		currentPage = state.currentPage;
		levelProps = state.levelProps;
		soundsReady = state.soundsReady;

		maxScore = levelProps.maxScore;
		score = state.score;

		isVictory = state.isVictory;
		levelHeadphonesImage = levelProps.headphoneImage;
	});

	currentPage = currentPage || "GAME_MENU_PAGE";
</script>

{#if !soundsReady}
	<Loader />
{:else}
	{#if currentPage == 'GAME_MENU_PAGE'}
		<GameMenu />
	{/if}

	{#if currentPage == 'GAME_TUTORIAL_PAGE'}
		<GameTutorial backgroundImage={levelProps.backgroundImage} />
	{/if}

	{#if currentPage == 'GAME_COUNTDOWN_PAGE'}
		<Countdown backgroundImage={levelProps.backgroundImage} />
	{/if}

	{#if currentPage == 'GAME_PAGE'}
		<Game
			backgroundImage={levelProps.backgroundImage}
			headphoneImage={levelProps.headphoneImage}
			genre={levelProps.genre}
			{isNewGame}
			{score}
			{maxScore} />
	{/if}

	{#if currentPage == 'GAME_PAUSE'}
		<GamePause
			genre={levelProps.genre}
			backgroundImage={levelProps.backgroundImage}
			{score}
			{maxScore} />
	{/if}

	{#if currentPage == 'GAME_END'}
		<GameEnd {score} {maxScore} {isVictory} {levelHeadphonesImage} />
	{/if}
{/if}
